<template >
    <form >
        <div class="text-xs text-gray-400 mb-1">Einstellungen › Mein Account</div>
        <div class="text-gray-900 flex items-center gap-3 mb-2" >
            <div class="text-lg font-medium" >
                Mein Account
            </div >
        </div >

        <div class="sm:hidden mb-5" >
            <label for="tabs" class="sr-only" >Select a tab</label >
            <select id="tabs" name="tabs"
                    v-model="currentTab"
                    class="block w-full rounded-md border-gray-300 focus:border-secondary focus:ring-secondary" >
                <option v-for="tab in tabs" @change="currentTab = tab" >{{ tab }}
                </option >
            </select >
        </div >
        <div class="hidden sm:block mb-5" >
            <nav class="flex space-x-4" aria-label="Tabs" >
                <span v-for="tab in tabs"
                      :class="[tab == currentTab ? 'bg-secondary text-white' : 'text-gray-500 hover:text-gray-700', 'px-3 py-2 font-medium text-sm rounded-md cursor-pointer']"
                      :aria-current="tab == currentTab ? 'page' : undefined"
                      @click="currentTab = tab" >
                    {{ tab }}
                </span >
                <a v-if="user.dhl_invoices" :href="user.dhl_invoices" target="_blank"
                   class="text-gray-500 hover:text-gray-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer flex items-center" >
                    <span >DHL Rechnungen</span >
                    <ArrowTopRightOnSquareIcon class="h-3.5 ml-2" />
                </a >
            </nav >
        </div >

        <div class="flex flex-col justify-between h-full" >
            <div v-if="validationErrors.hints.length" >
                <ul class="list-disc list-inside grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-x-4 text-primary-dark" >
                    <li v-for="hint in validationErrors.hints" >{{ hint }}</li >
                </ul >
                <hr class="my-5" >
            </div >

            <div v-show="currentTab == 'Account'" >
                <div class="text-sm font-semibold text-gray-900 mb-4" >
                    Benutzer
                </div >
                <div class="mt-2 grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4" >
                    <div >
                        <label for="username" class="block text-sm font-medium text-gray-700" >Benutzername</label >
                        <div class="mt-1" >
                            <input disabled type="text"
                                   class="bg-gray-100 block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                   :value="user.username" />
                        </div >
                    </div >
                    <div >
                        <label for="email" class="block text-sm font-medium text-gray-700" >E-Mail</label >
                        <div class="mt-1" >
                            <input v-model="user.email" type="text" id="email" name="email"
                                   autocomplete="off"
                                   class="block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                   :class="validationErrors.fields.email ? ['!border-primary'] : []"
                                   @change="validateAgain" />
                        </div >
                    </div >
                </div >

                <hr class="my-5" >

                <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-4" >
                    <div >
                        <div class="text-sm font-semibold text-gray-900 mb-3">Tastatursteuerung</div>
                        <div class="space-y-2 text-sm">
                            <div class="flex items-center gap-2">
                                <kbd class="px-2 py-0.5 bg-gray-100 rounded text-xs font-mono text-gray-600">←</kbd>
                                <kbd class="px-2 py-0.5 bg-gray-100 rounded text-xs font-mono text-gray-600">→</kbd>
                                <span class="text-gray-500">Tab wechseln</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <kbd class="px-2 py-0.5 bg-gray-100 rounded text-xs font-mono text-gray-600">↑</kbd>
                                <kbd class="px-2 py-0.5 bg-gray-100 rounded text-xs font-mono text-gray-600">↓</kbd>
                                <span class="text-gray-500">Vorheriger / Nächster Eintrag</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <kbd class="px-2 py-0.5 bg-gray-100 rounded text-xs font-mono text-gray-600">Esc</kbd>
                                <span class="text-gray-500">Fenster schließen</span>
                            </div>
                        </div>
                    </div >

                    <div >
                        <div class="text-sm font-semibold text-gray-900 mb-4" >
                            Passwort
                        </div >

                        <div class="mb-4" >
                            <label for="password" class="block text-sm font-medium text-gray-700" >Aktuelles
                                Passwort</label >
                            <div class="mt-1" >
                                <input v-model="user.password" type="password" id="password" name="password"
                                       autocomplete="current-password"
                                       class="block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                       :class="validationErrors.fields.password ? ['!border-primary'] : []"
                                       @change="validateAgain" />
                            </div >
                        </div >

                        <div class="mb-4" >
                            <label for="newPassword" class="block text-sm font-medium text-gray-700" >Neues
                                Passwort</label >
                            <div class="mt-1" >
                                <input v-model="user.newPassword" type="password" id="newPassword"
                                       name="newPassword"
                                       autocomplete="new-password"
                                       class="block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                       :class="validationErrors.fields.newPassword ? ['!border-primary'] : []"
                                       @change="validateAgain" />
                            </div >
                        </div >

                        <div class="mb-4" >
                            <label for="newPasswordRepeat" class="block text-sm font-medium text-gray-700" >Neues
                                Passwort Wiederholen</label >
                            <div class="mt-1" >
                                <input v-model="user.newPasswordRepeat" type="password" id="newPasswordRepeat"
                                       name="newPasswordRepeat"
                                       autocomplete="new-password"
                                       class="block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                       :class="validationErrors.fields.passwordRepeat ? ['!border-primary'] : []"
                                       @change="validateAgain" />
                            </div >
                        </div >
                    </div >
                </div >
            </div >
            <div v-show="currentTab == 'Benachrichtigungen'" >
                <div class="text-sm font-semibold text-gray-900 mb-4" >
                    Benachrichtigungseinstellungen
                </div >
                <div class="mt-4 grid grid-cols-1" >
                    <div class="flex mb-3 gap-x-10" v-for="(notificationOption, index) in user.notification_options"
                         :key="notificationOption.notification" >
                        <div class="flex items-center w-1/3 " >
                            {{ notificationOption.notification }}
                        </div >
                        <div >
                            <fieldset >
                                <legend class="sr-only" >Benachrichtigungs-Typ</legend >
                                <div class="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0" >
                                    <div class="flex items-center" >
                                        <input :id="`none-${index}`" :name="notificationOption.notification"
                                               type="radio" :checked="notificationOption.type == 'none'"
                                               class="h-4 w-4 border-gray-300 text-secondary-dark focus:ring-secondary-dark" />
                                        <label :for="`none-${index}`"
                                               class="ml-3 block text-sm font-medium leading-6 text-gray-900" >Keine</label >
                                    </div >
                                    <div class="flex items-center" >
                                        <input :id="`email-${index}`" :name="notificationOption.notification"
                                               type="radio" :checked="notificationOption.type == 'email'"
                                               class="h-4 w-4 border-gray-300 text-secondary-dark focus:ring-secondary-dark" />
                                        <label :for="`email-${index}`"
                                               class="ml-3 block text-sm font-medium leading-6 text-gray-900" >E-Mail</label >
                                    </div >
                                    <div class="flex items-center" >
                                        <input :id="`in-app-${index}`" :name="notificationOption.notification"
                                               type="radio" :checked="notificationOption.type == 'in-app'"
                                               class="h-4 w-4 border-gray-300 text-secondary-dark focus:ring-secondary-dark" />
                                        <label :for="`in-app-${index}`"
                                               class="ml-3 block text-sm font-medium leading-6 text-gray-900" >In-App</label >
                                    </div >
                                    <div class="flex items-center" >
                                        <input :id="`both-${index}`" :name="notificationOption.notification"
                                               type="radio" :checked="notificationOption.type == 'both'"
                                               class="h-4 w-4 border-gray-300 text-secondary-dark focus:ring-secondary-dark" />
                                        <label :for="`both-${index}`"
                                               class="ml-3 block text-sm font-medium leading-6 text-gray-900" >Beides</label >
                                    </div >
                                </div >
                            </fieldset >
                        </div >
                    </div >
                </div >
            </div >

            <div v-show="currentTab == 'Tags'" >
                <div class="mt-4 grid grid-cols-1" >
                    <TagManagement />
                </div >
            </div >

            <div v-show="currentTab == 'API'" >
                <div class="text-center py-10 opacity-60">
                    <div class="mx-auto w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                        <svg class="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" />
                        </svg>
                    </div>
                    <div class="text-sm font-semibold text-gray-900 mb-1">API-Zugang</div>
                    <p class="text-sm text-gray-500 mb-4">Erstelle API-Keys für den externen Zugriff auf deine Daten.</p>
                    <span class="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-500">
                        Bald verfügbar
                    </span>
                </div>
            </div>

            <div v-show="currentTab == 'Changelog'" >
                <div class="space-y-0">
                    <div v-for="(entry, index) in changelog" :key="entry.version"
                         class="relative pl-6 pb-8 last:pb-0">
                        <div v-if="index < changelog.length - 1" class="absolute left-[7px] top-3 bottom-0 w-px bg-gray-200"></div>
                        <div class="absolute left-0 top-[7px] h-[15px] w-[15px] rounded-full border-2"
                             :class="index === 0 ? 'bg-secondary border-secondary' : 'bg-white border-gray-300'"></div>

                        <div class="flex items-baseline gap-3 cursor-pointer select-none"
                             @click="index === 0 ? null : toggleChangelog(index)">
                            <span class="text-sm font-semibold text-gray-900">{{ entry.version }}</span>
                            <span class="text-xs text-gray-400">{{ entry.date }}</span>
                            <span class="text-xs text-gray-400">{{ entry.title }}</span>
                            <svg v-if="index > 0" class="h-3.5 w-3.5 text-gray-400 transition-transform ml-auto flex-shrink-0"
                                 :class="{ 'rotate-180': expandedChangelog.includes(index) }"
                                 fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>

                        <div v-show="index === 0 || expandedChangelog.includes(index)" class="mt-3">
                            <div v-if="entry.features.length" class="mb-3">
                                <div class="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">Neue Funktionen</div>
                                <ul class="space-y-1.5">
                                    <li v-for="f in entry.features" :key="f.name" class="text-sm text-gray-700 leading-relaxed">
                                        <span class="font-medium text-gray-900">{{ f.name }}.</span> {{ f.desc }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="entry.improvements.length">
                                <div class="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">Verbesserungen</div>
                                <ul class="space-y-1">
                                    <li v-for="imp in entry.improvements" :key="imp" class="text-sm text-gray-500 leading-relaxed">
                                        {{ imp }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

        <div class="mt-8 flex justify-between" v-if="currentTab !== 'Tags' && currentTab !== 'API' && currentTab !== 'Changelog'" >
            <button type="button"
                    @click="$emit('close-me')"
                    class="rounded-md border border-transparent bg-secondary py-2 px-4 text-sm text-white shadow-sm hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:bg-secondary-dark focus:ring-offset-2 focus:ring-offset-gray-50" >
                Abbrechen
            </button >
            <button type="button"
                    @click="updateUser"
                    class="rounded-md border border-transparent bg-primary py-2 px-4 text-sm text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:bg-primary-dark focus:ring-offset-2 focus:ring-offset-gray-50" >
                Speichern
            </button >
        </div >
    </form >
</template >

<script >
import {
    ArrowTopRightOnSquareIcon,
    CheckIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    PencilSquareIcon,
    PlusIcon,
    TrashIcon
} from '@heroicons/vue/24/outline'
import Steps from './Steps.vue'
import Multiselect from '@vueform/multiselect'
import TagManagement from "./TagManagement.vue";


export default {
    components: {
        TagManagement,
        PlusIcon,
        TrashIcon,
        CheckIcon,
        ExclamationTriangleIcon,
        InformationCircleIcon,
        PencilSquareIcon,
        Steps,
        Multiselect,
        ArrowTopRightOnSquareIcon,
    },

    props: [
        "userId",
    ],

    data() {
        return {
            submitSuccess: undefined,
            step: 0,
            submitError: null,
            validationErrors: {
                fields: {},
                hints: [],
                message: null,
            },
            user: {
                "customers": [],
                "categories": [],
                "dhl_invoices": '',
                "status": '',
                "role": '',
                "username": '',
                "email": '',
                // TODO: Remove this when backend is ready
                "notification_options": [
                    {
                        notification: 'Neuer Adressfehler',
                        type: 'both'
                    },
                    {
                        notification: 'Neue Überbestellung',
                        type: 'both'
                    },
                    {
                        notification: 'Auftrag wurde storniert',
                        type: 'both'
                    },
                    {
                        notification: 'Neue Retouren',
                        type: 'both'
                    },
                    {
                        notification: 'Lieferung in Bearbeitung',
                        type: 'both'
                    },
                    {
                        notification: 'Lieferung abgeschlossen',
                        type: 'both'
                    },
                    {
                        notification: 'Negativbestand Artikel',
                        type: 'both'
                    },
                    {
                        notification: 'Neuer Auftrag',
                        type: 'both'
                    },
                ],
            },
            tabs: [
                "Account",
                // "Benachrichtigungen",
                "Tags",
                "API",
                "Changelog",
            ],
            currentTab: 'Account',
            expandedChangelog: [],
            changelog: [
                {
                    version: '1.4', date: '09.04.2026', title: 'Feinschliff',
                    features: [
                        { name: 'Barcode-Label (Bestände)', desc: 'Artikel als druckfertiges 4 × 6 cm Label mit Code 128 Barcode, Name und Artikelnummer exportieren.' },
                        { name: 'Lade-Vorschau bei Neuigkeiten', desc: 'Während des Ladens werden animierte Platzhalter angezeigt statt einer leeren Fläche.' },
                    ],
                    improvements: [
                        'Status Teilversand: neue Farbe, automatisches Ausblenden sobald alle Packstücke zugestellt sind',
                        'Auftrag anlegen: Artikel-Dropdown zeigt Name, Nummer/GTIN und Verfügbarkeit als farbiges Badge',
                        'Leerer Positionen-Tab: Warnhinweis mit Zuweisungsfehler-Verdacht statt leerer Tabelle',
                        'Defekte Artikel: klarer Hinweis und durchgängig gedämpfte Darstellung im Modal',
                    ],
                },
                {
                    version: '1.3', date: '09.04.2026', title: 'Redesign & Tastatursteuerung',
                    features: [
                        { name: 'Tastatursteuerung', desc: 'Modals per Pfeiltasten bedienen: \u2190\u2192 wechselt Tabs bzw. Steps, \u2191\u2193 springt zum vorherigen oder n\u00e4chsten Eintrag, Esc schlie\u00dft das Fenster.' },
                        { name: 'Erneut versenden', desc: 'Auftr\u00e4ge und Retouren k\u00f6nnen direkt aus der Detailansicht erneut versendet werden \u2013 Kundendaten und Positionen werden automatisch \u00fcbernommen.' },
                        { name: 'Adress-Anzeige', desc: 'Lieferadressen in \u00fcbersichtlicher Karte mit Feldbezeichnungen. Per Klick kopierbar. Fehlerhafte Felder werden hervorgehoben.' },
                        { name: 'Export als PDF und Drucken', desc: 'Neben CSV k\u00f6nnen Daten jetzt auch als PDF oder direkt \u00fcber die Druckfunktion exportiert werden.' },
                        { name: 'PDF bei Lieferung anmelden', desc: 'Lieferanmeldungen k\u00f6nnen als PDF-Dokument heruntergeladen werden.' },
                        { name: 'Neuigkeiten', desc: 'Meldungen werden direkt auf dem Dashboard als Karten angezeigt \u2013 scrollbar und mit Zeitstempel.' },
                        { name: 'Changelog', desc: 'Der Changelog ist jetzt direkt in Mein Account einsehbar.' },
                        { name: 'Tags verwalten', desc: '\u00dcberarbeitetes Design der Tag-Verwaltung mit verbesserter Bedienbarkeit.' },
                        { name: 'Schnelleres Laden', desc: 'Animierte Platzhalter ersetzen den bisherigen Ladebalken \u2013 die App f\u00fchlt sich deutlich schneller an.' },
                        { name: 'API-Zugang (Vorschau)', desc: 'Neuer Bereich in Mein Account als Vorbereitung f\u00fcr die kommende API-Integration.' },
                    ],
                    improvements: [
                        'Modernisiertes Design: neue Schrift, einheitliche Farben und Abst\u00e4nde',
                        'Best\u00e4nde: \u00dcbersicht mit Karten-Darstellung, negativer Bestand orange, Defekt-Artikel kursiv',
                        'Trackingstatus: Karten-Layout mit Details unter der Trackingnummer',
                        'Retouren: Verlinkung zum Originalauftrag mit Icon',
                        'Tags aktualisieren sich sofort in der Liste',
                        'PDF-Export bei gro\u00dfen Datenmengen auf 5.000 Eintr\u00e4ge begrenzt',
                        'Stabile Modal-H\u00f6he \u2013 kein Springen mehr beim Tab-Wechsel',
                        'Bis zu 25 Positionen auf einen Blick sichtbar (vorher 5)',
                        'Favoriten-Stern aktualisiert sich sofort ohne Neuladen',
                        'Gelesen/Ungelesen-Status reagiert sofort',
                        'Verbesserte Formulargestaltung bei Auftrag anlegen und Lieferung anmelden',
                        'Einheitliches Datumsformat DD.MM.YYYY',
                        'Optimierte Ladezeit durch reduzierte Bundle-Gr\u00f6\u00dfe',
                    ],
                },
                {
                    version: '1.2.3', date: '27.12.2025', title: 'Notizen, Notizen',
                    features: [
                        { name: 'Notizen', desc: 'Eigene Notizen in der Modalansicht anlegen und verwalten.' },
                        { name: 'Namenssuche', desc: 'Suche von Vor- und Nachname nun gemeinsam m\u00f6glich.' },
                        { name: 'Check Hausnummer bei Import', desc: 'Orders mit fehlenden Hausnummern werden als Adressfehler angezeigt.' },
                    ],
                    improvements: [
                        'Verbesserte Ladezeit der Dashboard-Ansicht',
                        'Favicon wieder sichtbar',
                        'Login-Meldung bei falschen Daten',
                    ],
                },
                {
                    version: '1.2.2', date: '14.08.2025', title: 'Feedback & MHD-Features',
                    features: [
                        { name: 'Kommentar Retouren', desc: 'Retouren mit Kommentar werden durch Filter und Icon hervorgehoben.' },
                        { name: '\u00dcberbestellung manuelle Auftr\u00e4ge', desc: 'Artikel ohne Bestand k\u00f6nnen per Toggle eingef\u00fcgt werden.' },
                        { name: 'Meldungen', desc: 'Aktuelle Meldungen der Knowledge Base auf der Dashboard-Startseite.' },
                        { name: 'Export MHD', desc: 'CSV-Export f\u00fcr Auftragspositionen und Best\u00e4nde inkl. MHD-Daten.' },
                    ],
                    improvements: [
                        'Optimierte Modal- und Listenbreite',
                        'Lieferstatus in Fulfillment umbenannt',
                    ],
                },
                {
                    version: '1.2.1', date: '25.02.2025', title: 'Mehr Tags & alle gelesen',
                    features: [
                        { name: 'Tags Auftr\u00e4ge', desc: 'Individuelle Tags nun auch im Reiter Auftr\u00e4ge verf\u00fcgbar.' },
                        { name: 'Bulkverarbeitung', desc: 'Markierte oder alle Eintr\u00e4ge gleichzeitig auf gelesen/ungelesen setzen.' },
                        { name: 'Redesign Men\u00fc', desc: 'Miniversion bei schmaler Ansicht & Summe ungesehener Eintr\u00e4ge.' },
                    ],
                    improvements: [
                        'Verbesserte Ladezeiten bei Retouren und Lieferungen',
                    ],
                },
                {
                    version: '1.2', date: '15.11.2024', title: 'Favoriten, Tags & Usability',
                    features: [
                        { name: 'Tags', desc: 'Individuelle Tags mit Farbcodierung und Filter in allen Listen.' },
                        { name: 'Favoriten', desc: 'Auftr\u00e4ge, Artikel, Lieferungen oder Retouren favorisieren und filtern.' },
                        { name: 'Retouren-Status', desc: 'Unbearbeitete Retouren als ungesehen anzeigen und filtern.' },
                        { name: 'DHL Status in Liste', desc: 'DHL Versandstatus direkt in der Auftrags\u00fcbersicht.' },
                        { name: 'Dashboard Redesign', desc: 'Neue Funktionen und Schnellzugriff-Buttons.' },
                    ],
                    improvements: [
                        'Deutlich verbesserte Login- und Abfrage-Performance',
                        'Sonderfeld f\u00fcr Artikelstammdaten und SKU in Auftragsliste',
                    ],
                },
                {
                    version: '1.1.3', date: '25.07.2024', title: 'CSV-Export erweitert',
                    features: [
                        { name: 'Export Retouren & Lieferungen', desc: 'Erweiterter CSV-Export mit Details zu einzelnen Positionen.' },
                    ],
                    improvements: ['Layout-Problem bei Firefox behoben'],
                },
                {
                    version: '1.1.2', date: '15.02.2024', title: 'Mobile Performance',
                    features: [
                        { name: 'Mobile (Beta)', desc: 'Optimierte Bedienbarkeit auf Smartphones.' },
                        { name: 'Status Lieferungen', desc: 'Angefangene Lieferungen mit Status in Bearbeitung.' },
                    ],
                    improvements: ['Performance im Mobile Browser verbessert'],
                },
                {
                    version: '1.1.1', date: '25.08.2023', title: 'Auftrag anlegen',
                    features: [
                        { name: 'Lieferung anmelden', desc: 'Lieferungen direkt im Dashboard anmelden.' },
                        { name: 'Nachforschung', desc: 'Nachforschungsauftr\u00e4ge f\u00fcr verlorene Pakete direkt \u00fcbermitteln.' },
                    ],
                    improvements: ['Safari-Login-Fehler und \u00dcberbestellungs-Anzeige behoben'],
                },
                {
                    version: '1.1', date: '31.03.2023', title: 'Redesign Dashboard',
                    features: [
                        { name: 'Dashboard', desc: 'Kennzahlen, Grafik und aktuelle Probleme auf einen Blick.' },
                        { name: 'DHL Tracking API', desc: 'Versand-Status direkt im Dashboard abfragen.' },
                        { name: 'Auftrag manuell', desc: 'Auftr\u00e4ge direkt \u00fcber das Dashboard anlegen.' },
                    ],
                    improvements: ['Redesign aller Funktionen, schnellerer Suchfilter'],
                },
                {
                    version: '1.0', date: '09.11.2021', title: 'Erstes Release',
                    features: [
                        { name: 'Auftrags\u00fcbersicht', desc: 'Interne und externe Auftragsnummern mit DHL Trackingstatus.' },
                        { name: 'Best\u00e4nde & Artikeldaten', desc: 'Name, EAN, HAN, Bestand verf\u00fcgbar/gesamt/in Auftr\u00e4gen.' },
                        { name: 'Retouren\u00fcbersicht', desc: 'Positionen, Artikelmenge und Zustand.' },
                    ],
                    improvements: [],
                },
            ],
        };
    },

    methods: {
        cycleTab(direction) {
            const idx = this.tabs.indexOf(this.currentTab);
            const next = idx + direction;
            if (next >= 0 && next < this.tabs.length) this.currentTab = this.tabs[next];
        },

        toggleChangelog(index) {
            const i = this.expandedChangelog.indexOf(index);
            if (i === -1) { this.expandedChangelog.push(index); }
            else { this.expandedChangelog.splice(i, 1); }
        },

        close() {
            this.$emit('modal-close');
        },


        resetValidation() {
            this.validationErrors = {
                fields: {
                    positions: []
                },
                hints: [],
                message: null,
                validated: false,
                valid: true,
            }
        },

        validate() {
            this.resetValidation();
            if (!this.user.email) {
                this.validationErrors.fields.email = true;
                this.validationErrors.hints.push('E-Mail-Adresse fehlt');
                this.validationErrors.valid = false;
            }
            if ((this.user.newPassword || this.user.newPasswordRepeat) && !this.user.password) {
                this.validationErrors.fields.password = true;
                this.validationErrors.hints.push('Aktuelles Passwort muss zum Ändern des Passwortes angegeben werden');
                this.validationErrors.valid = false;
            }
            if (this.user.newPassword != this.user.newPasswordRepeat) {
                this.validationErrors.fields.newPassword = this.validationErrors.fields.newPasswordRepeat = true;
                this.validationErrors.hints.push('Passwort stimmt nicht überein');
                this.validationErrors.valid = false;
            }
            this.validationErrors.validated = true;
            return this.validationErrors.valid;
        },

        validateAgain() {
            if (this.validationErrors.validated) {
                this.validate();
            }
        },

        updateUser() {
            if (this.validate()) {
                axios.post('/api/my-account', this.user)
                    .then(response => {
                        this.submitSuccess = true;
                        this.$emit('close-me');
                    })
                    .catch(error => {
                        this.$swal({
                            title: 'Änderungen nicht gespeichert',
                            text: error.message,
                            icon: 'error',
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                    });
            }
        },

        fetchUser() {
            axios.get('/api/my-account')
                .then(response => {
                    this.user = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        async confirmDelete() {
            try {
                let confirmation = await this.$swal({
                    text: `Benutzer ${this.user.username} wirklich löschen?`,
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Löschen',
                    cancelButtonText: 'Abbrechen',
                })

                if (confirmation.isConfirmed) {
                    let response = await axios.delete('/api/users/' + this.user.id);
                    window.$toast?.show(`Benutzer ${this.user.username} gelöscht`);
                    this.$emit('close-me');
                }
            } catch (error) {
                this.$swal({
                    title: 'Fehler',
                    text: error.message,
                    showConfirmButton: true,
                });
            }


        }
    },

    mounted() {
        this.fetchUser();
    },
}
</script >
